import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";

interface Props {
  title: string;
  isOptional?: true;
  isFill?: true;
  alignStart?: true;
  margin?: string;
}
const InputLines: React.FC<Props> = ({
  alignStart,
  isOptional,
  isFill,
  title,
  children,
  margin,
}) => {
  return (
    <StyledInputWrapper margin={margin} alignStart={alignStart}>
      <StyledInputTitle>
        {title}
        {!isOptional && <RequiredStar>*</RequiredStar>}
      </StyledInputTitle>
      <StyledInputContent isFill={isFill}>{children}</StyledInputContent>
    </StyledInputWrapper>
  );
};
export default InputLines;
const StyledInputWrapper = styled.div<{ margin?: string; alignStart?: true }>`
  display: flex;
  width: 100%;
  justify-content: flex-start;

  align-items: ${({ alignStart }) => (alignStart ? "flex-start" : "center")};
  margin-bottom: ${({ margin }) => margin || "24px"};
  min-height: 32px;
`;
const StyledInputTitle = styled.div`
  flex: 0 0 165px;

  display: flex;
  height: 32px;
  flex-wrap: nowrap;
  ${theme.typo.heading.b14};
  line-height: 32px;
`;
const StyledInputContent = styled.div<{ isFill?: true }>`
  width: ${({ isFill }) => isFill && "100%"};
`;

const RequiredStar = styled.div`
  color: ${theme.colors.red3};
  margin-left: 4px;
`;
